import Page from "./Page";
import Template from "./Title.ejs";
import Events from "../Utils/EventLite";


export default class Title extends Page {
    constructor() {
        super(Template, {}, "Title");
        this.element.classList.add("fullscreen");
    }
    handleButton(e) {
        Events.trigger("goto", "Story");
    }
}



// WEBPACK FOOTER //
// ./src/views/Title.js